import { parseSiteSchema, type SiteSchema } from '~/utils/validation/siteSchema'

export {
  TEXT_PROP_KEYS,
  isLocalizedText,
  parseSiteSchema,
  safeParseSiteSchema,
  siteSchema,
  type Block,
  type LocalizedText,
  type Page,
  type SiteSchema,
} from '~/utils/validation/siteSchema'

/**
 * Validates a SiteSchema. Throws with a descriptive message on failure.
 */
export function validateSiteSchema(schema: unknown): asserts schema is SiteSchema {
  parseSiteSchema(schema)
}
